import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
export function Hero() {
  return <section className="pt-6 pb-8 px-5 md:pt-20 md:pb-28 md:px-6 max-w-6xl mx-auto grid md:grid-cols-2 gap-5 md:gap-12 items-center" data-id="element-79">
      <motion.div initial={{
      opacity: 0,
      x: -20
    }} animate={{
      opacity: 1,
      x: 0
    }} transition={{
      duration: 0.6
    }} className="space-y-4 md:space-y-7" data-id="element-80">
        <h1 className="text-[2rem] leading-[1.1] md:text-6xl lg:text-7xl font-bold md:leading-[1.05] tracking-tight text-[#2D1F1A]" data-id="element-81">
          ALIMENTA A TU BEBÉ{' '}
          <span className="text-[#F9A8B7]" data-id="element-82">SANO Y SIN ESTRÉS</span> EN MENOS DE{' '}
          <span className="underline decoration-[#A9D7E2] decoration-4 underline-offset-4" data-id="element-83">
            15 MINUTOS
          </span>{' '}
          AL DÍA
        </h1>
        <p className="text-base md:text-2xl text-gray-700 leading-snug md:leading-relaxed" data-id="element-84">
          <span className="font-bold text-[#2D1F1A]" data-id="element-85">
            500+ recetas paso a paso
          </span>
          , menús semanales ya hechos, y{' '}
          <em className="text-[#2D1F1A]" data-id="element-86">
            la tranquilidad de saber EXACTAMENTE qué darle a tu bebé
          </em>{' '}
          hoy, mañana y todos los días.
        </p>
        <div className="flex items-center gap-2 text-xs md:text-base font-bold text-[#2D1F1A]" data-id="element-87">
          <span className="text-yellow-500 text-base md:text-lg" data-id="element-88">
            ⭐⭐⭐⭐⭐
          </span>
          <span data-id="element-89">+10,000 mamás felices</span>
        </div>
        <div className="pt-1 md:pt-2" data-id="element-90">
          <Button data-id="element-91">QUIERO MIS RECETAS</Button>
        </div>
      </motion.div>
      <motion.div initial={{
      opacity: 0,
      x: 20
    }} animate={{
      opacity: 1,
      x: 0
    }} transition={{
      duration: 0.6,
      delay: 0.2
    }} className="relative" data-id="element-92">
        <img src="https://cdn.magicpatterns.com/uploads/cX562tf8vQqBbtxwfGvZrp/mockup_ebook.png" alt="Ebook 500 Recetas para Introducción Alimentaria + Recetario semanal con lista de compras" loading="eager" className="w-full h-auto object-contain" data-id="element-93" />
      </motion.div>
    </section>;
}